import { render, staticRenderFns } from "./OrderShowOne.vue?vue&type=template&id=077592e6&"
import script from "./OrderShowOne.vue?vue&type=script&lang=js&"
export * from "./OrderShowOne.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports